(function () {
  var DESKTOP = '(min-width: 990px)';

  function initCarousel(carousel) {
    if (carousel.getAttribute('data-ak-rev-ready')) return;
    carousel.setAttribute('data-ak-rev-ready', 'true');

    var root = carousel.closest('[data-ak-rev]') || carousel;
    var viewport = carousel.querySelector('[data-ak-rev-viewport]');
    var track = carousel.querySelector('[data-ak-rev-track]');
    var prev = carousel.querySelector('[data-ak-rev-prev]');
    var next = carousel.querySelector('[data-ak-rev-next]');
    var progress = root.querySelector('[data-ak-rev-progress]');
    var cards = [].slice.call(carousel.querySelectorAll('[data-ak-rev-card]'));
    if (!viewport || !track || cards.length === 0) return;

    var desktop = window.matchMedia(DESKTOP);
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function isDesktop() { return desktop.matches; }

    function gapSize() {
      var style = getComputedStyle(track);
      return parseFloat(style.columnGap || style.gap) || 0;
    }

    function cardStep() {
      if (!isDesktop()) {
        return cards[0].getBoundingClientRect().width + gapSize();
      }
      return viewport.clientWidth;
    }

    function maxScroll() {
      return Math.max(0, track.scrollWidth - viewport.clientWidth);
    }

    function update() {
      var max = maxScroll();
      var left = viewport.scrollLeft;
      if (prev) prev.disabled = left <= 2;
      if (next) next.disabled = left >= max - 2;
      if (progress) {
        var frac = track.scrollWidth ? Math.min(1, viewport.clientWidth / track.scrollWidth) : 1;
        var pos = max > 0 ? left / max : 0;
        progress.style.width = (frac * 100).toFixed(2) + '%';
        progress.style.marginLeft = (pos * (1 - frac) * 100).toFixed(2) + '%';
      }
    }

    function scrollBy(direction) {
      var target = viewport.scrollLeft + direction * cardStep();
      var max = maxScroll();
      if (target < 0) target = 0;
      if (target > max) target = max;
      viewport.scrollTo({ left: target, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }

    function syncKeyboard() {
      // On desktop the viewport cannot scroll (the nav buttons drive it), so
      // keep it out of the tab order there and focusable on phones.
      viewport.setAttribute('tabindex', isDesktop() ? '-1' : '0');
    }

    if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
    if (next) next.addEventListener('click', function () { scrollBy(1); });

    viewport.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        scrollBy(1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        scrollBy(-1);
      }
    });

    viewport.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function () {
      syncKeyboard();
      update();
    });
    if (desktop.addEventListener) desktop.addEventListener('change', function () { syncKeyboard(); update(); });

    syncKeyboard();
    update();
    window.setTimeout(update, 120);
  }

  function init() {
    var carousels = document.querySelectorAll('[data-ak-rev-carousel]');
    Array.prototype.forEach.call(carousels, initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
